import React from 'react';

interface ISuccessProps {
  email: string;
  priceUF: string;
  priceCLP: string;
  proposal: number;
  reset: () => void;
}

export default function Success(props: ISuccessProps) {
  const { email, reset } = props;

  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-10 wizard-card message message__success mt50">
            <div className="row">
              <div className="col-12 text-center message--title">
                <h1>¡Felicitaciones!</h1>
              </div>
              <div className="col-12 col-sm-10 mx-auto">
                <div className="row">
                  <div className="col-12 col-sm-3 col-md-2 message--icon-container">
                    <i className="material-icons message--icon">check</i>
                  </div>
                  <div className="col-12 col-sm-9 col-md-10">
                    <p>
                      Estamos procesando tu solicitud de incorporación al&nbsp;
                      <b>Seguro de Accidentes Personales.</b>
                    </p>
                    <p>
                      Recibirás tu póliza y condiciones generales en un plazo de <b>48 horas</b> a tu correo electrónico&nbsp;
                      <span className="text-bold">{email}</span>
                    </p>
                    <p>
                      Importante: Todos los datos proporcionados deberán de estar completos y correctos para que tu póliza pueda ser emitida.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-4 mx-auto mt20">
                <button
                  className="btn primary start-over-again"
                  type="button"
                  onClick={reset}
                >
                  Adquirir otro seguro
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
